import type { InfiniteData, QueryKey } from '@tanstack/query-core'
import { cloneDeep } from 'lodash-es'
import queryClient from './queryClient'

export function prepareToRefetchListQuery<TData>(queryKey: QueryKey) {
	queryClient.setQueryData(queryKey, (prev: InfiniteData<TData>) => ({
		pages: prev?.pages.slice(0, 1) ?? [],
		pageParams: prev?.pageParams.slice(0, 1) ?? [],
	}))
}

export function prependToInfiniteData<TData>(queryKey: QueryKey, data: Array<TData>): void
export function prependToInfiniteData<TData>(queryKey: QueryKey, data: TData): void
export function prependToInfiniteData<TData>(queryKey: QueryKey, data: TData | Array<TData>): void {
	queryClient.setQueryData(queryKey, (prev: InfiniteData<{ data: TData[] }>) => {
		const firstPage = cloneDeep(prev?.pages.slice(0, 1)?.[0])
		const restPages = prev?.pages.slice(1)

		if (firstPage) {
			const nextData = (Array.isArray(data) ? data : [data]).concat(firstPage.data)
			firstPage.data = nextData
		}

		return {
			pages: [firstPage, ...restPages],
			pageParams: prev?.pageParams ?? [],
		}
	})
}

export function removeFromInfiniteData<TData extends { id: string }>(
	queryKey: QueryKey,
	id: string
): void {
	queryClient.setQueryData(queryKey, (prev: InfiniteData<{ data: TData[] }> | undefined) => {
		if (!prev) return prev

		return {
			...prev,
			pages: prev.pages.map((page) => ({
				...page,
				data: page.data.filter((item) => item.id !== id),
			})),
		}
	})
}
